import { debounce } from 'lodash';
import { headerHeight, fullHeaderHeight } from '../../scripts/helpers';
import { showBackdrop, hideBackdrop } from '../components/backdrop';
import { atQuery } from '../components/mediaQueries';

const minicartDrawer = document.querySelector('#CartDrawer');
const initMinicart = () => {
  if (!minicartDrawer) return;

  const closeBtn = minicartDrawer.querySelector('.minicart__close');
  if (closeBtn) closeBtn.addEventListener('click', () => closeMinicart());

  document.querySelectorAll('#PageContainer, #header').forEach((backdropPlaceholder) =>
    backdropPlaceholder.addEventListener('click', () => {
      closeMinicart;
    }),
  );

  minicartDrawer.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMinicart();
  });

  loadMinicart();
};

const lineUpdate = (productRow, lineIndex, quantity) => {
  productRow.classList.add('loading');
  ShopifyAPI.changeItem(
    lineIndex,
    quantity,
    () => {
      loadMinicart();
    },
    (XMLHttpRequest, textStatus) => {
      productRow.classList.remove('loading');
      const errorWrapper = productRow.querySelector('.minicart__product-error');
      if (errorWrapper && XMLHttpRequest?.responseJSON?.description) {
        errorWrapper.innerText = XMLHttpRequest.responseJSON.description;
        errorWrapper.classList.remove('hidden');
        setTimeout(() => {
          errorWrapper.classList.add('hidden');
        }, 3000);
      }
    },
  );
};

const initQtyButtons = () => {
  if (!minicartDrawer) return;
  minicartDrawer
    .querySelectorAll('.minicart__product[data-line-index]')
    .forEach((productRow) => {
      const lineIndex = productRow.dataset.lineIndex;
      const qtyContainer = productRow.querySelector('.minicart__product-qty');
      if (qtyContainer) {
        const minusBtn = qtyContainer.querySelector(
          '.minicart__product-qty-change--minus',
        );
        const plusBtn = qtyContainer.querySelector(
          '.minicart__product-qty-change--plus',
        );
        const qtyInput = qtyContainer.querySelector(
          '.minicart__product-qty-value',
        );

        if (minusBtn && plusBtn && qtyInput) {
          const stock =
            qtyInput?.dataset?.stock >= 0 ? qtyInput.dataset.stock : -1;

          minusBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const newValue = parseInt(qtyInput.value) - 1;
            if (newValue > 0) {
              plusBtn.disabled = false;
              lineUpdate(productRow, lineIndex, newValue);

              if (newValue <= 1) {
                minusBtn.disabled = true;
              }
            }
          });

          plusBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const newValue = parseInt(qtyInput.value) + 1;
            if (stock >= 0) {
              if (stock >= newValue) {
                minusBtn.disabled = false;

                if (stock == newValue) {
                  plusBtn.disabled = true;
                }
                lineUpdate(productRow, lineIndex, newValue);
              }
            } else {
              lineUpdate(productRow, lineIndex, newValue);
            }
          });
        }
      }

      const removeLink = productRow.querySelector('a.minicart__product-remove');
      if (removeLink && removeLink.href) {
        removeLink.addEventListener('click', (e) => {
          e.preventDefault();
          lineUpdate(productRow, lineIndex, 0);
        });
      }
    });
};

const initVatField = () => {
  if (!minicartDrawer) return;
  const submit = minicartDrawer.querySelector('[type="submit"]');
  const vatWrapper = minicartDrawer.querySelector(
    'fieldset.minicart__invoice-wrapper',
  );
  if (!vatWrapper) return;
  const vatPatterns = [
    /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/,
    /^[0-9]{11}$/,
  ];
  const requestInvoice = vatWrapper.querySelector('input[type="checkbox"]');
  const vatField = vatWrapper.querySelector('input[type="text"]');
  const errorWrapper = vatWrapper.querySelector('.minicart__invoice-error');

  if (requestInvoice && vatField && errorWrapper) {
    requestInvoice.addEventListener('change', () => {
      if (requestInvoice.checked) {
        requestInvoice.value = 'Yes';
        vatField.classList.remove('hidden');
      } else {
        requestInvoice.value = 'No';
        vatField.classList.add('hidden');
        vatField.value = '';
      }
    });

    vatField.addEventListener('blur', () => {
      errorWrapper.innerText = '';
      errorWrapper.classList.add('hidden');
      if (
        requestInvoice.checked &&
        vatField.value.search(vatPatterns[0]) < 0 &&
        vatField.value.search(vatPatterns[1]) < 0
      ) {
        errorWrapper.innerText = errorWrapper.dataset.formatError;
        errorWrapper.classList.remove('hidden');
      }
    });

    const submitChanges = debounce(() => {
      errorWrapper.innerText = '';
      errorWrapper.classList.add('hidden');
      var requestInvoiceValue = 'No';
      var vatValue = '';
      if (requestInvoice.checked) {
        if (
          vatField.value.search(vatPatterns[0]) >= 0 ||
          vatField.value.search(vatPatterns[1]) >= 0
        ) {
          requestInvoiceValue = 'Yes';
          vatValue = vatField.value;
          if (submit) submit.disabled = false;
        } else {
          if (submit) submit.disabled = true;
        }
      } else {
        if (submit) submit.disabled = false;
      }

      ShopifyAPI.updateCartAttributes(
        `${requestInvoice.name}=${requestInvoiceValue}&${vatField.name}=${vatValue}`,
        () => {},
        (XMLHttpRequest, textStatus) => {
          if (XMLHttpRequest?.responseJSON?.description) {
            errorWrapper.innerText = XMLHttpRequest.responseJSON.description;
            errorWrapper.classList.remove('hidden');
          }
        },
      );
    }, 100);
    vatWrapper.addEventListener('input', submitChanges);
  }
};

const loadMinicart = async () => {
  if (!minicartDrawer) return;

  if (window.innerWidth <= 768) {
    minicartDrawer.style.maxHeight = 'calc(100dvh - ' + fullHeaderHeight() + 'px)';
  }

  await fetch(`${Shopify.routes.root}cart?view=minicart`)
    .then(async (res) => res.text())
    .then((data) => {
      const minicartDom = new DOMParser().parseFromString(data, 'text/html');
      const minicartContent = minicartDom.querySelector('#MinicartContent');
      const minicartDrawerContent =
        minicartDrawer.querySelector('.minicart__content');
      if (minicartContent && minicartDrawerContent) {
        minicartDrawerContent.innerHTML = minicartContent.innerHTML;
      }
    });

  initQtyButtons();
  initVatField();
};

const openMinicart = () => {
  if (!minicartDrawer) return;

  if (window.innerWidth <= 768) {
    minicartDrawer.style.maxHeight = 'calc(100dvh - ' + fullHeaderHeight() + 'px)';
  }

  minicartDrawer.classList.add('minicart__drawer--open');
  minicartDrawer.focus();
  document.querySelector('html').classList.add('minicart-open');
  atQuery('min', 'md', () => {
    showBackdrop();
  });
};

const closeMinicart = () => {
  if (!minicartDrawer) return;
  minicartDrawer.classList.remove('minicart__drawer--open');
  minicartDrawer.blur();
  document.querySelector('html').classList.remove('minicart-open');
  atQuery('min', 'md', () => {
    hideBackdrop();
  });

  atQuery('max', 'md', () => {
    const $header = $('.header__container');
    if ($header.length <= 0) return;

    $header.removeClass('force-opacity');
    if ($(window).scrollTop() === 0) {
      $header.addClass('apply-transparency');
    }
  })
};

export { initMinicart, openMinicart, closeMinicart, loadMinicart };
